import React from 'react';
import { IconButton, Snackbar, SnackbarContent } from '@mui/material';

import { CloseIcon } from '../../../assets/icons';
import { makeStyles } from '../../../utils/mui';

const useStyles = makeStyles()(theme => ({
  successToast: {
    color: theme.palette.info.main,
    backgroundColor: theme.palette.info.light,
    boxShadow: 'none',
  },
  errorToast: {
    color: theme.palette.error.main,
    backgroundColor: theme.palette.error.light,
    boxShadow: 'none',
  },
  infoToast: {
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.secondary.light,
    boxShadow: 'none',
  },
}));

interface IToast {
  isOpen: boolean;
  message: string;
  type: 'success' | 'info' | 'error';
  autoHideDuration?: number;
  onClose: (event: React.SyntheticEvent<any> | Event, reason?: string) => void;
}

const Toast: React.FC<IToast> = props => {
  const { classes } = useStyles();
  const { isOpen, type, message, autoHideDuration, onClose } = props;

  let className = classes.successToast;
  switch (type) {
    case 'success':
      className = classes.successToast;
      break;
    case 'info':
      className = classes.infoToast;
      break;
    case 'error':
      className = classes.errorToast;
      break;
    default:
      className = classes.successToast;
      break;
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={autoHideDuration || 6000}
      open={isOpen}
      onClose={onClose}
    >
      <SnackbarContent
        className={className}
        message={message}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </>
        }
      />
    </Snackbar>
  );
};

export default Toast;
